module.exports = __webpack_public_path__ + "static/media/filter-sidebar-unassigned.71e2ac42.svg";